import PropTypes from "prop-types";
import {
  Box,
  Divider,
  Drawer,
  Typography,
  useMediaQuery,
  Tooltip,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { NavItem } from "../nav-item";
import { IconNavItem } from "../icon-nav-item";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import PeopleIcon from "@mui/icons-material/People";
import MedicationIcon from "@mui/icons-material/Medication";
import { Isotipo } from "../../assets/isotipo";
import { Isologotipo } from "../../assets/isoLogotipo";

const items = [
  {
    href: "/dashboard",
    icon: <HomeIcon fontSize="small" />,
    title: "Inicio",
    key: "dashboard",
  },
  {
    href: "/my-patients",
    icon: <PeopleIcon fontSize="small" />,
    title: "Mis pacientes",
    key: "my-patients",
  },
  {
    href: "/my-prescriptions/new",
    icon: <MedicationIcon fontSize="small" />,
    title: "Mis recetas",
    key: "my-prescriptions",
  },
];

export const PageSidebarDoctor = (props) => {
  const { open, openPersistent, onClose, status } = props;

  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"), {
    defaultMatches: true,
    noSsr: false,
  });

  const allowedStates = ["0", "2", "3", "4"];

  let filteredItems = [];

  if (status === "1") {
    filteredItems = items;
  } else {
    filteredItems = items.filter((item) => item.key === "dashboard");
  }

  const content = (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
          textAlign: "center"
        }}
      >
        <div>
          <Box sx={{ px: 2, pt: 3 }}>
            {!openPersistent && (
              <Isotipo/>
            )}
            {openPersistent && (
              <Box
                sx={{
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.04)",
                  display: "flex",
                  justifyContent: "space-between",
                  px: 2,
                  py: "11px",
                  borderRadius: 1,
                }}
              >
                <Isologotipo/>
              </Box>
            )}
          </Box>
        </div>
        <Divider
          sx={{
            borderColor: "#2D3748",
            my: 3,
          }}
        />

        <Box sx={{ flexGrow: 1 }}>
          {filteredItems.map((item, index) =>
            openPersistent ? (
              <NavItem
                key={index}
                icon={item.icon}
                href={item.href}
                title={item.title}
                disabled={allowedStates.includes(status)}
              />
            ) : (
              <Tooltip title={item.title} placement="right">
                <div>
                  <IconNavItem
                    key={index}
                    icon={item.icon}
                    href={item.href}
                    title={item.title}
                  />
                </div>
              </Tooltip>
            )
          )}
        </Box>

        <Divider sx={{ borderColor: "#2D3748" }} />
      </Box>
    </>
  );

  const contentMobile = (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
        }}
      >
        <div>
          <Box sx={{ px: 4, pt: 3 }}>
            {openPersistent ? (
              <Isotipo/>
            ):(
              <Box
                sx={{
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.04)",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  px: 2,
                  py: "11px",
                  borderRadius: 1,
                }}
              >
                <Isologotipo/>
                {/* <div>
                  <Typography color="inherit" variant="subtitle1">
                    Virtual Doctor
                  </Typography>
                  <Typography
                    color="neutral.400"
                    variant="subtitle1"
                    sx={{ fontSize: "0.85rem" }}
                  >
                    Recetas medicas online
                  </Typography>
                </div> */}
              </Box>
            )}
          </Box>
        </div>
        <Divider
          sx={{
            borderColor: "#2D3748",
            my: 3,
          }}
        />
        <Box sx={{ flexGrow: 1 }}>
          {filteredItems.map((item, index) =>
              <NavItem
                key={index}
                icon={item.icon}
                href={item.href}
                title={item.title}
                disabled={allowedStates.includes(status)}
              />
          )}
        </Box>

        <Divider sx={{ borderColor: "#2D3748" }} />
      </Box>
    </>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open={openPersistent}
        PaperProps={
          openPersistent
            ? {
                sx: {
                  backgroundColor: "neutral.900",
                  color: "#FFFFFF",
                  width: 280,
                },
              }
            : {
                sx: {
                  backgroundColor: "neutral.900",
                  color: "#FFFFFF",
                  width: 65,
                },
              }
        }
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "neutral.900",
          color: "#FFFFFF",
          width: 280,
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {contentMobile}
    </Drawer>
  );
};

PageSidebarDoctor.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
